module.exports = {
      id: "illustrations:AU03-usage",
      viewBox: "0 0 231 233",
      url: "/static/" + "sprites.1e5806fb7235408b9281f0924c9110c8.svg#illustrations:AU03-usage",
      toString: function () {
        return this.url;
      }
    }